/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { useEffect, useState } from 'react';
import { MAGIC_VALUE } from '../Utils/Constants';
import { getStepperBadgeColor } from '../Utils/ManualUpload/ManualUploadUtils';
import ChooseServiceIcon from '../../../images/ChooseService.svg';
import './StepperCommon.scss';

interface IStepper {
  defaultIndex: number;
  children: React.ReactElement[];
  allowHeaderNavigation: boolean;
}

function CustomStepper(props: IStepper) {
  const { defaultIndex, children, allowHeaderNavigation } = props;
  const [ActiveIndex, setActiveIndex] = useState(defaultIndex);
  useEffect(() => {
    setActiveIndex(defaultIndex);
  }, [defaultIndex]);
  const moveNext = (index: number) => {
    if (allowHeaderNavigation && ActiveIndex + 1 === index) {
      setActiveIndex(index);
    }
  };
  return (
    <>
      <div className="custom-stepper-navigation">
        {children.map((child, index) => {
          return (
            <React.Fragment key={`stepper-${child.props.header}`}>
              <div
                className={
                  ActiveIndex === index
                    ? 'modal-tab-active-header pb-10'
                    : 'pb-10'
                }
              >
                <button
                  className="stepper-nav-button"
                  onClick={() => moveNext(index)}
                >
                  {ActiveIndex <= index && (
                    <div
                      className={`custom-badge-stepper ${getStepperBadgeColor(
                        ActiveIndex,
                        index
                      )}`}
                    >
                      {index + 1}
                    </div>
                  )}
                  {ActiveIndex > index && (
                    <div className="service-icon">
                      <img src={ChooseServiceIcon} />
                    </div>
                  )}
                  <span className="stepper-tab-header">
                    {child.props.header}
                  </span>
                </button>
              </div>
              {index <= children.length - MAGIC_VALUE.TWO && (
                <div className="stepper-buttons-separator"></div>
              )}
            </React.Fragment>
          );
        })}
      </div>
      <div>{children[ActiveIndex].props.children}</div>
    </>
  );
}

export function Item(props: { children: React.ReactNode; header: string }) {
  return <></>;
}
CustomStepper.Item = Item;
export default CustomStepper;
